import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, ornament, rect, text } from "./kit";
import type { LabelTemplate } from "./types";

// Art Deco: a rising sunburst, the name in a gold-edged band, a pair of fans.
function wine(): CanvasData {
  const b = "wine";
  const band = { x: 8, y: 46, width: 74, height: 16 };
  return doc(b, INK.black, [
    // sunburst's sun centre is SVG (100, 100): sit it just above the band.
    ornament("sunburst", INK.gold, { width: 60, at: [45, 43.4], anchor: [100, 100] }),
    rect(INK.gold, band, 0.4, INK.charcoal),
    // Poiret One capitals are 0.75 em: baseline = band centre + half the cap height.
    text({ text: "YOUR NAME", font: "poiret-one", size: 6, color: INK.gold, baseline: band.y + band.height / 2 + 3, x: band.x, width: band.width, tracking: 0.3 }),
    centred(b, { text: "MMXXVI", font: "cinzel", size: 2.5, color: INK.gold, baseline: 70, tracking: 0.3 }),
    ornament("deco-fan", INK.gold, { width: 22, at: [31, 84.5] }),
    ornament("deco-fan", INK.gold, { width: 22, at: [59, 84.5] }),
  ]);
}

export const artDeco: LabelTemplate = {
  key: "art-deco",
  name: "Art Deco",
  occasion: "modern",
  style: "Art Deco",
  description: "A sunburst, fans and a banded name in gold on black.",
  hasImageSlot: false,
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
